<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="m-3">
            <h2>Edit Post</h2>
            <div v-if="pageLoading" class="mt-3">
                Loading...
            </div>
            <EditElement :elementIdProp="postId" category_id="1"></EditElement>
        </div>
    </div>
</template>

<script>
import EditElement from "@/components/ElementComponents/EditElement";
export default {
    name: 'editPost',
    components: {
        EditElement,
    },
    data() {
        return {
            itemsBread: [{
                text: 'Home',
                to: '/dashboard'
            }, {
                text: 'Posts',
                to: '/posts/all'
            }, {
                text: 'Edit Post',
                to: '/post/:id'
            },],
            postId: null,
        };
    },
    created() {
        this.postId = this.$route.params.id;
    },
}
</script>